import moment from 'moment';
import type { Result } from './conditions/result';

type ValidationErrors = Record<string, string[]>;

export type Condition = {
  id: number | null;
  kyccId: number | null;
  name: string | null;
  birthday: string | null;
  note: string | null;
  errors: ValidationErrors;
  results: Array<Result>;
};

export const defaultCondition: Condition = {
  id: null,
  kyccId: null,
  name: null,
  birthday: null,
  note: null,
  errors: {},
  results: [],
};

export function validate(form: Condition): boolean {
  form.errors = {};
  if (form.name == null || form.name === '') {
    form.errors['name'] = ['を入力してください'];
  }

  if (form.birthday != null && !moment(form.birthday).isValid) {
    form.errors['birthday'] = ['正しい日付を入力してください'];
  }

  return Object.keys(form.errors).length === 0;
}

export function hasError(condition: Condition, field: string): boolean {
  const errorMessages = Object.getOwnPropertyDescriptor(
    condition.errors,
    field,
  )?.value;
  return Array.isArray(errorMessages) && errorMessages.length > 0;
}
